import { useEPeticeDetailContext } from '@gov-nx/module/page';
import {
	Attachment,
	DocumentDownloadContainer,
	LayoutGap,
} from '@gov-nx/ui/web';

export const EPetitionPetitionersAttachments = () => {
	const {
		ePetitionPetitionersAttachments: { attachments, isVisible, strings },
	} = useEPeticeDetailContext();

	if (!isVisible) return null;

	return (
		<LayoutGap gap="m">
			<p>{strings.heading}</p>
			<DocumentDownloadContainer>
				{attachments.map((attachment) => (
					<Attachment
						key={attachment.name}
						downloadLabel={attachment.downloadLabel}
						name={attachment.name}
						size={attachment.size}
						onDownload={attachment.onDownload}
					/>
				))}
			</DocumentDownloadContainer>
		</LayoutGap>
	);
};
